import { render, staticRenderFns } from "./TipoCarnet.vue?vue&type=template&id=db634df8&"
import script from "./TipoCarnet.vue?vue&type=script&lang=js&"
export * from "./TipoCarnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports